import { getHelper, getBase } from "lib/api";

const ADMIN_URL = getBase('admin');

export const loadUsers = (session, onSuccess, onError = console.error) => {
  const url = `${ADMIN_URL}/account/${session.accountId}/user`;

  getHelper(session, url, onSuccess, onError);
};
